import { festival, STATUS } from "@types";
import { FC, useMemo } from "react";
import BoughtFooterCard from "./bought-footer-card";
import CommonFooterCard from "./common-footer-card";
import CardDivider from "./card-divider";
import { useLayoutContext } from "@context/layout";
import SubscriptionCardFooter from "./suscription-footer-card";
import { CARD_VARIANT, CURRENT_STATUS } from "../types";
import { useIsMobile } from "@shared/hooks/useIsMobile";
import PublishFooter from "../publish-footer";
import {
  Button,
  BUTTON_COLOR,
  BUTTON_SIZE,
  BUTTON_VARIANT,
} from "@shared/components/button";
import ArrowLeft from "@svg/new-design/arrow-left";
import FreeFooter from "../free-footer";

interface Props {
  isBuy: boolean;
  status?: STATUS;
  price: number | undefined;

  watchPercent: number;
  // eslint-disable-next-line no-unused-vars
  submitRate: ((id: number) => void) | undefined;
  id: number;
  festival?: festival;
  showShoppingCart: boolean;
  variant: CARD_VARIANT;
  inCart?: boolean;
  sku: string;
  hasCertificate?: boolean;
  renderSubscriptionFooter?: boolean;
}

const CardFooter: FC<Props> = (props) => {
  const {
    isBuy,
    status = STATUS.PUBLISHED,
    price,

    watchPercent,
    festival,
    submitRate,
    id,
    showShoppingCart,
    sku,
    inCart,
    hasCertificate,
    variant,
    renderSubscriptionFooter,
  } = props;
  const isMobile = useIsMobile();
  const salePrice = festival?.price_on_festival;

  const { subscriptionData } = useLayoutContext();
  const hasActiveSubscription = Boolean(subscriptionData?.is_active);

  const showDivider = !variant || variant === CARD_VARIANT.GRID;

  const isPercentDiscount = festival?.is_percent;
  const discount = hasActiveSubscription
    ? undefined
    : festival?.discount_value;
  const boughtLabel = watchPercent
    ? watchPercent === 100
      ? hasCertificate
        ? isMobile
          ? "گواهینامه"
          : "دریافت گواهینامه"
        : "امتیاز شما؟"
      : "ادامه یادگیری"
    : "شروع یادگیری";

  const getBoughtLabel = () => {
    if (!watchPercent) return "شروع یادگیری";

    if (watchPercent === 100) {
      if (hasCertificate) {
        return isMobile ? "گواهینامه" : "دریافت گواهینامه";
      }
      return "امتیاز شما؟";
    }

    return "ادامه یادگیری";
  };

  const currentStatus = useMemo(() => {
    if (renderSubscriptionFooter) return CURRENT_STATUS.SUBSCRIPTION;
    if (status !== STATUS.PUBLISHED) return CURRENT_STATUS.NOT_PUBLISH;
    else if (price === 0 && !isBuy) return CURRENT_STATUS.FREE;
    else if (isBuy) {
      if (watchPercent || !hasActiveSubscription) return CURRENT_STATUS.BOUGHT;
      else return CURRENT_STATUS.SUBSCRIPTION;
    } else return CURRENT_STATUS.DEFAULT;
  }, [hasActiveSubscription, isBuy, price, status]);

  const footerComponent = {
    [CURRENT_STATUS.NOT_PUBLISH]: (
      <PublishFooter showDivider={showDivider} status={status} />
    ),
    [CURRENT_STATUS.BOUGHT]: (
      <BoughtFooterCard
        watchPercent={watchPercent}
        boughtLabel={getBoughtLabel()}
        hasCertificate={hasCertificate}
      />
    ),
    [CURRENT_STATUS.FREE]: (
      <>
        <CardDivider showDivider={showDivider} />
        <div className="flex justify-between items-center h-fds-34 sm:h-9   -mt-[1px]">
          <p className="sm:body-md body-sm text-fds-secondary">رایگان</p>
          <Button
            onClick={() =>
              watchPercent === 100 ? submitRate?.(id || 0) : undefined
            }
            variant={BUTTON_VARIANT.TEXT_ACTION}
            color={BUTTON_COLOR.PRIMARY}
            endIcon={
              variant !== CARD_VARIANT.GRID || !isMobile ? (
                <ArrowLeft className="sm:h-5 sm:w-5 h-4 w-4" />
              ) : null
            }
            size={BUTTON_SIZE.MEDIUM}
          >
            {isBuy ? "ادامه یادگیری" : "شروع یادگیری"}
          </Button>
        </div>
      </>
    ),
    [CURRENT_STATUS.SUBSCRIPTION]: (
      <SubscriptionCardFooter
        price={price}
        variant={variant}
        renderSubscriptionFooter={renderSubscriptionFooter}
      />
    ),
    [CURRENT_STATUS.DEFAULT]: (
      <CommonFooterCard
        showShoppingCart={showShoppingCart}
        salePrice={salePrice}
        price={price}
        discount={discount}
        isPercentDiscount={isPercentDiscount}
        id={id}
        sku={sku}
        inCart={inCart}
        showDivider={showDivider}
      />
    ),
  };
  return <div className="w-full">{footerComponent[currentStatus]}</div>;
};

export default CardFooter;
